/**
 * api-产品列表
 */
import { post } from '@/utils/http'
// 产品列表
export const apiGetCategoryList = p => post('/Bcategory/getCategoryList.do', p)
// 新增产品
export const apiAddCategory = p => post('/Bcategory/addCategory.do', p)
// 修改产品
export const apiEditCategory = p => post('/Bcategory/editCategory.do', p)
// 删除产品
export const apiDelCategory = p => post('/Bcategory/delCategory.do', p)
// 新增积分商品
export const apiAddPoint = p => post('/pointsMall/addPoint.do', p)
// 编辑积分商品
export const apiEditGoods = p => post('/pointsMall/editGoods.do', p)
// 删除积分商品
export const apiDeleteGoods = p => post('/pointsMall/deleteGoods.do', p)
// 获取积分商城的商品列表
export const apiGetGoodsList = p => post('/pointsMall/getGoodsList.do', p)
// 新增商品规格
export const apiAddPointsUnit = p => post('/pointsMall/addPointsUnit.do', p)
// 编辑商品规格
export const apiEditPointsUnit = p => post('/pointsMall/editPointsUnit.do', p)
// 删除商品规格
export const apiDelPointsUnit = p => post('/pointsMall/delPointsUnit.do', p)
